// extracted by mini-css-extract-plugin
export const playerbutton = "style-module--playerbutton--3MHR4";